module.exports = __webpack_public_path__ + "static/img/role007.7f5e8a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role007.jpg
// module id = au0B
// module chunks = 1